import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { Box } from '@mui/material';
import { SearchAppBar } from './BiasInfoAppBar';
import { WorkspaceNew } from '../../orders/workspace/WorkspaceNew';
import { resetPath } from '../../../actions/files';
import { useDispatch } from 'react-redux';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

export const OrderRepo = ({ open, handleClose, numberOrder = null }) => {
	// Dispatch
	const dispatch = useDispatch();

	return (
		<div>
			{numberOrder && (
				<Dialog
					fullScreen
					open={open}
					onClose={handleClose}
					TransitionComponent={Transition}
				>
					{/* Content */}
					<Box sx={{ flexGrow: 1 }}>
						<SearchAppBar
							title={`No. de pedido: ${numberOrder}`}
							handleClose={() => {
								dispatch(resetPath());
								handleClose();
							}}
						/>
						<div style={{ padding: '20px' }}>
							<WorkspaceNew idOrder={numberOrder} />
						</div>
					</Box>
				</Dialog>
			)}
		</div>
	);
};
